export const employeeVerticalTableConfig = [
  {
    field: 'slNo',
    header: 'Sl. No',
    filter: false,
    visible: true,
    defaultPinned: true,
    sortable: false,
    order: 1,
    menuItems: [],
  },
  {
    field: 'employeeVertical',
    header: 'Employee Vertical',
    className: 'employee-list-data-column',
    headerClassName: 'employee-list-data-column',
    width: 180,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 2,
    menuItems: [],
  },
  {
    field: 'status',
    header: 'Status',
    className: 'employee-list-data-column',
    headerClassName: 'employee-list-data-column',
    width: 180,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 3,
    menuItems: [],
  },
  {
    field: 'utilizationStatus',
    header: 'Utilization Status',
    className: 'employee-list-data-column',
    headerClassName: 'employee-list-data-column',
    width: 180,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 4,
    menuItems: [],
  },
  {
    field: 'action',
    header: 'Action',
    className: 'employee-list-data-column employee-list-action-column',
    headerClassName: 'employee-list-data-column employee-list-action-column',
    width: 180,
    exportable: false,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 5,
    menuItems: [],
  },
];
